import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectIsRTL } from 'store';

export const useIsRtlGridRerender = () => {
  const isRtl = useSelector(selectIsRTL);
  const [isRender, setIsRender] = useState(false);
  useEffect(() => {
    setIsRender(false);
  }, [isRtl]);
  useEffect(() => {
    if (!isRender) {
      setIsRender(true);
    }
  }, [setIsRender, isRender]);

  return { isRender, isRtl };
};
